<template> 
  <div style="height:480px">
    <h1 style="padding:20px">Error: 404 -  Page not found!</h1>
  </div>
</template>
<script>  
  export default {
  name: 'About'
}
</script>
